export default async (url) => {
  const response = await fetch(url)
  const html = await response.text()
  const doc = Document.parseHTMLUnsafe(html)
  return doc
}
